module.exports = __webpack_public_path__ + "static/bbis-powerflushing-22185cbfb170eb273c683b75da15ffd4.jpg";